import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const SCENES = [
  { work: 'travail_chauffeur', life: 'vie_enfant', workText: 'Finir sa journée devant des formulaires.', lifeText: 'Être là quand elle court vers vous.' },
  { work: 'travail_mecanicien', life: 'vie_peche', workText: "Chercher une information qui existe déjà.", lifeText: 'Une matinée de pêche, sans regarder l\'heure.' },
  { work: 'travail_repartiteur', life: 'vie_amis', workText: 'Courir après des réponses, encore.', lifeText: 'Arriver à temps pour le 5 à 7.' },
  { work: 'travail_bureau', life: 'vie_famille', workText: 'Ressaisir les mêmes données.', lifeText: 'Souper avec ceux qu\'on aime.' },
  { work: 'travail_chauffeur', life: 'vie_roulotte', workText: 'Rentrer quand tout le monde dort.', lifeText: 'Une soirée au bord du lac.' },
];
const FRAMES = SCENES.flatMap((s, i) => [
  { key: `${i}-w`, img: s.work, label: 'Vous avez ceci', text: s.workText, life: false },
  { key: `${i}-l`, img: s.life, label: 'Mais vous méritez ceci', text: s.lifeText, life: true },
]);
export const IMG = (name) => `/accueil/${name}.webp`;

const Frame = ({ f, active }) => (
  <div className={`absolute inset-0 transition-opacity duration-[2000ms] ease-in-out ${active ? 'opacity-100' : 'opacity-0'}`} aria-hidden={!active}>
    <img src={IMG(f.img)} alt="" className={`w-full h-full object-cover ${active ? 'pp-kenburns' : ''} ${f.life ? '' : 'saturate-[.55] brightness-[.8]'}`} />
  </div>
);

export const HeroContrast = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setI((i + 1) % FRAMES.length), FRAMES[i].life ? 6500 : 4500);
    return () => clearTimeout(t);
  }, [i]);
  const f = FRAMES[i];

  return (
    <section className="relative h-[100svh] min-h-[600px] overflow-hidden bg-[#0B0F19]" data-testid="hero-section">
      {FRAMES.map((x, j) => <Frame key={x.key} f={x} active={j === i} />)}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0F19]/50 via-[#0B0F19]/20 to-[#0B0F19]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F19]/80 via-[#0B0F19]/30 to-transparent" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 sm:px-10 flex flex-col justify-end pb-24 sm:pb-28">
        <div key={f.key} className="pp-caption mb-8" data-testid="hero-caption">
          <p className={`text-xs sm:text-sm uppercase tracking-[0.3em] font-semibold ${f.life ? 'text-amber-400' : 'text-slate-400'}`}>{f.label}</p>
          <p className="text-white/90 text-lg sm:text-xl mt-2 font-light">{f.text}</p>
        </div>
        <h1 className="font-heading text-6xl sm:text-7xl lg:text-[9rem] leading-[0.85] font-bold uppercase tracking-tight text-white" data-testid="hero-title">
          Vous méritez<br /><span className="text-amber-400">mieux.</span>
        </h1>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex gap-1.5" data-testid="hero-progress">
        {SCENES.map((_, s) => (
          <span key={s} className={`h-[3px] rounded-full transition-all duration-700 ${Math.floor(i / 2) === s ? 'w-10 bg-amber-400' : 'w-4 bg-white/25'}`} />
        ))}
      </div>
      <ChevronDown className="absolute bottom-10 right-8 text-white/40 animate-bounce hidden sm:block" size={26} />
    </section>
  );
};
